var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ep-auth-page"},[_c('div',{staticClass:"auth-result"},[_c('img',{attrs:{"src":require("../../assets/img/control/successs.png"),"alt":"","width":"80px","height":"80px"}})]),_vm._v(" "),_c('div',{staticClass:"content-body"},[_vm._v("\n     授权成功\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab8cb56","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/control/auth-result.vue
// module id = 928
// module chunks = 0